import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class JobTypeStore {
  jobTypeList = [];
  jobList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      jobTypeList: observable,
      total: observable,
      jobList: observable,
      loading: observable,

      addData: action,
      getJobTypeData: action,
      getJobData: action,
    });
    this.rootStore = rootStore;
  }

  async addData(values) {
    var postData = values;
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("jobRequestList/addJobType", postData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=delivery&a=addJobtype", "postData=" + base64Input);

    return response;
  }

  async getJobTypeData() {
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=salesperson&a=getJobType");

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("jobRequestList/getJobType");
    const allJobType = [{ jobId: "0", jobName: "All" }];
    this.jobTypeList = [...allJobType, ...response?.data?.data];
  }

  // async getJobData(){
  //   var postData = null
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi.getClient().post("index.php?c=salesperson&a=getJobType", "postData="+base64Input);

  //   this.jobList = response?.data?.data

  // }

  async getJobData() {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("jobRequestList/getJobType");

    this.jobList = response?.data?.data;
  }
}

export default JobTypeStore;
